<template>
	<v-sheet class="home" color="transparent">
		<VisitorLanding></VisitorLanding>
	</v-sheet>
</template>
<style>  
	.extend-row{
		margin-left: -20px !important;
		margin-right: -20px !important;
	}
</style>

<script>

	import Vuex from "vuex";
	import VisitorLanding from "@/components/content/VisitorLanding"
	// import UserLanding from "@/components/content/UserLanding"

	export default {
		name: 'Home',
		components: {
			// UserLanding,
			VisitorLanding
		},
		computed: {
			...Vuex.mapState({
				auth: state => state.auth
			})
		},
		data: () => {
			return {
				hello: "Becca"
			}
		}
	}
</script>
